import { AuthenticationService } from './../../../services/authentication.service';
import {Component, HostListener, OnInit} from '@angular/core';
import {EmailService} from '../../../services/email.service';
import {Attachment, Email} from '../../../types/email-data.types';
import {FilterStateItem} from '../../../services/filter-recipients';
import {UrlService} from '../../../services/url.service';

declare const toastr: any;
declare const $: any;

@Component({
    selector: 'email-view-modal',
    templateUrl: './email-view-modal.component.html',
    styleUrls: ['./email-view-modal.component.scss']
})
export class EmailViewComponent implements OnInit {
    showModal = false;
    data: Email;
    recipientFilterState: FilterStateItem[] = [];
    disabledSubmit = false;

    constructor(
        public es: EmailService,
        public urlService: UrlService,
        public authenticationService: AuthenticationService
    ) {}

    ngOnInit() {
        this.data = JSON.parse(JSON.stringify(this.es.emailInViewModal));
        this.recipientFilterState = this.data.filtersList;
        this.initSummernote();
        setTimeout(() => this.showModal = true, 300);
        this.urlService.modalOpened.emit();
    }

    initSummernote() {
        document.body.classList.add('body-upload-file-email');
        const summernote = $('#summernote');
        summernote.summernote({
            dialogsInBody: true,
            callbacks: this.isHideSumernoteTools() ? undefined : {
                onChange: contents => this.data.message = contents,
                onImageUpload: files => this.es.uploadFile(files, summernote),
                onMediaDelete: target => this.es.deleteFile(target, summernote)
            },
            toolbar: this.isHideSumernoteTools() ? [] : [
                ['style', ['style']],
                ['font', ['bold', 'italic', 'underline', 'clear']],
                ['fontname', ['fontname']],
                ['color', ['color']],
                ['para', ['ul', 'ol', 'paragraph']],
                ['table', ['table']],
                ['insert', ['link', 'hr', 'picture']],
                ['help', ['help']]
            ],
            fontNames: this.isHideSumernoteTools() ? undefined : ['Arial', 'open sans', 'Courier New'],
            disableDragAndDrop: true
        });
        $('.note-editable').html(this.data.message).on('focusout', e => {
            if ($(e.relatedTarget).closest('.note-toolbar').length) {
                summernote.summernote('editor.saveRange');
            }
        });
        if (this.isHideSumernoteTools()) {
            $('#summernote').summernote('disable');
        }
    }

    private isHideSumernoteTools(): boolean {
        return this.data.status !== 'draft' || this.authenticationService.userIsResident;
    }


    hideModal() {
        this.es.isEmailViewModalShow = false;
        this.es.emailInViewModal     = null;
        this.urlService.modalClosed.emit();
    }

    createCopy() {
        const email = new Email();

        // email.id              = this.data.id;
        email.sender           = this.data.sender;
        email.senderName       = this.data.senderName;
        email.subject          = this.data.subject;
        email.replyTo          = this.data.replyTo;
        email.replyToName      = this.data.replyToName;
        email.message          = this.data.message;
        email.pmName           = this.data.pmName;
        email.pmEmail          = this.data.pmEmail;
        email.pmMobilePhone    = this.data.pmMobilePhone;
        email.buildingName     = this.data.buildingName;
        email.buildingAddress  = this.data.buildingAddress;
        email.sendMeCopy       = this.data.sendMeCopy;
        email.status           = this.data.status;
        email.filtersList      = this.data.filtersList;
        email.recipients       = this.data.recipients;
        email.recipientsFilter = this.data.recipientsFilter;
        email.createdAt        = this.data.createdAt;
        email.attachments      = this.data.attachments.map(at => new Attachment(at.name, at.fileSize, at.path));

        this.es.emailInComposePage = email;
        this.hideModal();
        this.es.urlService.router.navigate(['/email-merge/compose']);
    }

    send() {
        this.disabledSubmit = true;
        const data = {
            status: 'in_progress',
            message: this.data.message
        };
        this.es.api.patch('domainEmails', `/api/v1/mailings/${this.data.id}`, data).subscribe(
            () => {
                toastr.success('Email successfully composed');
                this.es.emailInViewModal.status = 'in_progress';
                this.hideModal();
            },
            error => this.es.api.errorHandler(error, 'Compose email failed'),
            () =>  this.disabledSubmit = false
        );
    }

    showAttachment(item) {
        this.es.showAttachment(new Attachment(item.name, item.fileSize, item.path));
    }

    @HostListener('document:keydown.escape', ['$event']) onKeydownHandler(event: KeyboardEvent) {
        setTimeout(() => this.hideModal(), 100);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/email/email-view-modal/email-view-modal.component.ts